module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0696.09fc566f.jpg";